export default __webpack_public_path__ + "static/media/Rectangle 98.6ca035ab.png";